export default {
  methods: {
    normalize_requirement_type(type) {
      return String(type || '').toLowerCase().replace(/\s+/g, '_');
    },

    is_item_question_complete(item) {
      const applicable_questions = this.get_applicable_questions(Reflect.get(item, 'target_questions') || []);
      if (!applicable_questions.length) return false;
      return applicable_questions.every(question => Reflect.get(question, 'is_answered') === true);
    },

    get_question_requirement_details(item, question) {
      const statuses = Array.isArray(item?.requirement_statuses)
        ? item.requirement_statuses
        : [];

      return statuses.flatMap(status_item => {
        const normalized_type = this.normalize_requirement_type(status_item?.type);
        const details = Array.isArray(status_item?.details) ? status_item.details : [];
        return details
          .filter(detail => Number(detail?.question_id) === Number(question?.id))
          .map(detail => ({
            ...detail,
            requirement_type: normalized_type,
            requirement_type_label: status_item?.type || 'Requirement'
          }));
      });
    },

    is_question_condition_met(item, question) {
      if (!question?.is_answered) {
        return false;
      }

      const check_mode = String(item?.check_mode || '').toLowerCase();
      const is_manual_checked = item?.manual_checked === true || item?.completed_by === 'manual';
      if (check_mode === 'manual' && is_manual_checked) {
        return true;
      }

      const details = this.get_question_requirement_details(item, question);
      if (!details.length) {
        return true;
      }

      return details.every(detail => detail?.is_met === true);
    },

    get_question_status_variant(item, question) {
      if (!question?.is_answered) return 'unanswered';
      return this.is_question_condition_met(item, question) ? 'passed' : 'failed';
    },

    get_question_check_reasons(item, question) {
      const details = this.get_question_requirement_details(item, question);
      return details.map(detail => ({
        type: detail?.requirement_type_label || 'Requirement',
        is_met: detail?.is_met === true,
        message: detail?.message || ''
      }));
    },

    get_question_reason_key(item, question) {
      return `${item?.id || 'item'}_${question?.id || 'question'}`;
    },

    get_question_reason_visibility_value(key) {
      const visibility_map = this.question_reason_visibility || {};
      return Reflect.get(visibility_map, key) === true;
    },

    toggle_question_reasons(item, question) {
      const key = this.get_question_reason_key(item, question);
      const current = this.get_question_reason_visibility_value(key);
      const visibility_map = {
        ...(this.question_reason_visibility || {})
      };
      Reflect.set(visibility_map, key, !current);
      this.question_reason_visibility = {
        ...visibility_map
      };
    },

    is_question_reasons_open(item, question) {
      const key = this.get_question_reason_key(item, question);
      return this.get_question_reason_visibility_value(key);
    }
  }
};
